import {
  FC,
  useState,
  Key,
  CSSProperties,
  ChangeEvent,
  useEffect,
} from 'react';
import { ProTree, ProInput } from '../antd';
import { TreeProps } from 'antd/lib/tree';
import useDebounce from '../Hooks/useDebounce';
import { getParentKey, loop } from './util';
import './style.less';

export interface SuperTreeProps extends TreeProps {
  /** 是否可搜索 */
  hideSearch?: boolean;
  /** 选择框默认文字 */
  searchPlaceholder?: string;
  /** 样式 */
  searchStyle?: CSSProperties;
  /** 搜索框的值改变时触发调用 */
  onSearchChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}
/**
 * 树形控件
 */
export const SuperTree: FC<SuperTreeProps> = props => {
  const {
    defaultExpandedKeys,
    expandedKeys,
    autoExpandParent,
    hideSearch,
    searchPlaceholder,
    searchStyle,
    onSearchChange,
    treeData,
    ...resProps
  } = props;
  if (!treeData || treeData.length === 0) return null;
  const [currentAutoExpandParent, setCurrentAutoExpandParent] = useState<
    boolean
  >(autoExpandParent || false);
  const [currentExpandedKeys, setCurrentExpandedKeys] = useState<Key[]>(
    defaultExpandedKeys || [],
  );
  const [searchValue, setSearchValue] = useState<string>();
  const debouncedValue = useDebounce(searchValue, 300);
  useEffect(() => {
    if (!treeData || debouncedValue === undefined) return;
    const currentValue = debouncedValue.trim();
    const keys: Key[] = currentValue
      ? getParentKey(treeData, currentValue, [])
      : [];
    setCurrentExpandedKeys(keys);
    setSearchValue(currentValue);
    setCurrentAutoExpandParent(true);
  }, [debouncedValue]);
  const handleExpand = (expandedKeys: Key[]) => {
    setCurrentExpandedKeys(expandedKeys);
    setCurrentAutoExpandParent(false);
  };
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchValue(value);
    onSearchChange?.(event);
  };
  return (
    <>
      {!hideSearch && (
        <ProInput.Search
          placeholder={searchPlaceholder}
          style={searchStyle}
          onChange={handleChange}
        />
      )}
      <ProTree
        onExpand={handleExpand}
        expandedKeys={currentExpandedKeys}
        autoExpandParent={currentAutoExpandParent}
        treeData={treeData ? loop(treeData, searchValue) : []}
        {...resProps}
      />
    </>
  );
};
SuperTree.defaultProps = {
  showLine: true,
  showIcon: true,
  hideSearch: false,
};

export default SuperTree;
